import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SpeakerListComponent } from './speaker-list.component';
import { AppMaterialModule } from '../../../material/material.module';
import { SpeakerListRoutingModule } from './speaker-list-routing.module';
import { SharedModule } from '../../../shared/shared.module';

@NgModule({
  declarations: [SpeakerListComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    SpeakerListRoutingModule,
    AppMaterialModule,
    SharedModule
  ],
  exports: [
    SpeakerListComponent
  ]
})
export class SpeakerListModule { }
